import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useParams, useLocation  } from 'react-router-dom';
import { Card, Button, Carousel, CardText, Nav} from 'react-bootstrap';
import { Play, Pause, Volume2, VolumeX, ChevronLeft, RotateCcw, RotateCw, Maximize, Minimize } from "lucide-react";
import ReactPlayer from 'react-player';
import intro from '../assets/AboutUsIntro.jpeg';
import Robert from '../assets/Robert_Rodriguez_Headshot.jpeg';
import Alexis from '../assets/alexis.jpg';
import Kevin from '../assets/kevin dartt.jpg';
import Nick from '../assets/NicholasOrtiz2.jpeg';
import Nixon from '../assets/Nixon.jpeg';
import AUBG from '../assets/AboutUSBG.mp4'; 


export default function About() {
    const [cardVisible, setCardVisible] = useState(false);
    const [media, setMedia] = useState({});
    const [savedTime, setSavedTime] = useState(0);
    const videoRef = useRef(null);
    const [isPlaying, setIsPlaying] = useState(false);
    const playerRef = useRef(null);
    const wrapperRef = useRef(null);
      const sliderRef = useRef(null);
    const [muted, setMuted] = useState(false);
    const [volume, setVolume] = useState(0.8);
    const [played, setPlayed] = useState(0);
    const [hasStarted, setHasStarted] = useState(false);
    const [showControls, setShowControls] = useState(false);

    const inactivityTimeoutRef = useRef(null);
    const [hoverX, setHoverX] = useState(null);
    const [hoverTime, setHoverTime] = useState(null);
    const [showVolumeSlider, setShowVolumeSlider] = React.useState(false);
    const [isFullscreen, setIsFullscreen] = React.useState(false);
    const lastPlayedTimeRef = useRef(0);
    const [showPoster, setShowPoster] = useState(true);


const togglePlayPause = () => {
  const internal = playerRef.current?.getInternalPlayer();
  if (!internal) return;

  if (isPlaying) {
    internal.pause();
  } else {
    internal.play();
  }
};


const handlePlay = () => {
  setIsPlaying(true);
  setHasStarted(true);
  setShowControls(true);
};

const handlePause = () => {
  setIsPlaying(false);
  setShowControls(true); // keep controls visible when paused
};

const handleEnded = () => {
  setIsPlaying(false);
  setShowControls(true);
};



const handleToggleFullscreen = () => {
  const el = wrapperRef.current;
  if (!el) return;

  if (!document.fullscreenElement) {
    el.requestFullscreen?.();
  } else {
    document.exitFullscreen?.();
  }
};




    useEffect(() => {
    const handleUserActivity = () => resetInactivityTimer();
  
    window.addEventListener('mousemove', handleUserActivity);
    window.addEventListener('touchstart', handleUserActivity);
  
    resetInactivityTimer(); // Start timer on mount
  
    return () => {
      window.removeEventListener('mousemove', handleUserActivity);
      window.removeEventListener('touchstart', handleUserActivity);
      if (inactivityTimeoutRef.current) {
        clearTimeout(inactivityTimeoutRef.current);
      }
    };
  }, []);

const resetInactivityTimer = () => {
  if (!isPlaying) return; // 👈 don’t auto-hide when paused

  setShowControls(true);

  clearTimeout(inactivityTimeoutRef.current);
  inactivityTimeoutRef.current = setTimeout(() => {
    setShowControls(false);
  }, 3000);
};


  const [duration, setDuration] = React.useState(0);
  const handleDuration = (dur) => {
    setDuration(dur);
  };
  const hideTimeoutRef = useRef(null);

  function formatTime(seconds) {
    const hrs = Math.floor(seconds / 3600);
    const mins = Math.floor((seconds % 3600) / 60);
    const secs = Math.floor(seconds % 60);
    
    if (hrs > 0) {
      return `${hrs}:${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
    } else {
      return `${mins}:${secs.toString().padStart(2, '0')}`;
    }
  }

  const currentTime = played * duration;
  const totalTime = duration;
  const isMobile = /Mobi|Android/i.test(navigator.userAgent);


  const handleRewind15 = () => {
    const currentTime = playerRef.current.getCurrentTime();
    playerRef.current.seekTo(Math.max(currentTime - 15, 0), 'seconds');
  };
  
  const handleForward15 = () => {
    const currentTime = playerRef.current.getCurrentTime();
    playerRef.current.seekTo(Math.min(currentTime + 15, duration), 'seconds');
  };

  
  

  const toggleMute = () => {
    setMuted((prev) => {
      const newMuted = !prev;
      if (videoRef.current) {
        videoRef.current.muted = newMuted;
      }
      return newMuted;
    });
  };

    const handleProgress = (state) => {
    setPlayed(state.played);
    lastPlayedTimeRef.current = state.played;
    localStorage.setItem(
  `video-player-time-${videoUrl}`,
  state.played.toString()
);

  };
  

      useEffect(() => {
    const fetchMedia = async () => {
      try {
        const response = await fetch('https://bkf.onrender.com/media'); // adjust URL to your backend
        const data = await response.json();
        // Convert array to object keyed by Webmedia for easier access
        const mediaObj = {};
        data.forEach(item => {
          mediaObj[item.Webmedia] = item;
        });
        setMedia(mediaObj);
      } catch (err) {
        console.error('Error fetching media:', err);
      }
    };

    fetchMedia();
  }, []);

  const videoUrl = media['RRPitch']?.videourl; 

  const CF_BASE = "https://d2b3xd88n081z3.cloudfront.net";


  return (
    <div
     style={{
          marginTop: '7%',
          // marginBottom: '7%'
        }}
    >

    <div className='d-flex justify-content-center '>
        <h1
        style={{
          // marginTop: '30px',
          marginBottom: '3%',
           WebkitTextStroke: '2px rgb(243, 174, 61)', // <-- outline around letters
            color: 'black', 
        }}
        >About Us</h1>
      </div>





<div>
  <div className='d-flex justify-content-center '>
       <h2
       style={{
       display: "inline-block",
        padding: '1%',
        justifyContent: 'center',
        fontWeight: "bold",
        fontSize: "1.5rem",
        padding: "0.2rem 0.6rem",
        margin: "0",  
        marginBottom: "0.5rem",          
        backgroundColor: 'rgba(20, 19, 19, 0.9)',
        backdropFilter: 'blur(8px)',           
        WebkitBackdropFilter: 'blur(8px)',
        borderRadius: '12px',
        // border: '2px solid rgb(179, 37, 25)',
        // boxShadow: `
        //   0 0 5px rgba(243, 174, 61, 0.6),
        //   0 0 10px rgba(243, 174, 61, 0.35)
        // `,          
          }}
     >
      IGNITED BY ACTION. FUELED BY FANS.
     </h2>
   </div>

        <div>
        <Card
          style={{
            maxWidth: '800px', 
            margin: "0 auto",
            marginBottom: "40px",
            textAlign: "center",
            backdropFilter: 'blur(8px)',           
             WebkitBackdropFilter: 'blur(8px)',
            padding: "0", // remove padding from Card to avoid clipping background
            transition: "opacity 0.6s ease 0.5s, transform 0.6s ease 0.5s",
            border: '2px solid rgb(179, 37, 25)',
            
            clipPath: "polygon(0 50%, 20px 0, calc(100% - 20px) 0, 100% 50%, calc(100% - 20px) 100%, 20px 100%)",
            position: 'relative', // for z-index control if needed
          }}
        >
          
          <CardText
            className='home-tag'
          style={{
    fontWeight: "bold",
    color: "silver",

    /* Core surface */
    backgroundColor: "rgba(15, 15, 15, 0.7)",
    backdropFilter: "blur(10px)",
    WebkitBackdropFilter: "blur(10px)",

    borderRadius: "12px",

    padding: "1rem",
    margin: "0",
  }}
          >
             Brass Knuckle Films is the new action film label from Robert Rodriguez, 
           creator of blockbuster hits such as Desperado, Spy Kids, Alita: Battle 
           Angel and Sin City. We are based out of Robert’s Troublemaker Studios 
           in Austin, Texas, where Robert has maximized efficiencies on all his 
           movies while pushing the boundaries of innovation and entertainment. 
            Using the Republic platform, Brass Knuckle Films has taken innovation 
           even further by giving fans an opportunity to invest in its inaugural 
           slate through a campaign that was launched (and oversubscribed) in 
           March of 2025. See below for the main campaign video or for more information 
           go to{" "}
            <a
              href="https://republic.com/rodriguez"
              className="custom-nav-link hover-brighten"
              style={{ color: 'silver' }}
            >
            <strong>Republic.com</strong>.
            </a>
          </CardText>
        </Card>
        </div>
   </div>

     
        <video
        // src={AUBG}
        src={`${CF_BASE}/public/AboutUSBG.mp4`} 
        autoPlay
        loop
        muted
        playsInline
          preload="auto"
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          zIndex: -1,
        }}
      >
        {/* <source src={AUBG} type="video/mp4" /> */}
        </video>

    <div className="netflix-player-wrapper" ref={wrapperRef}
          style={{
        width: '100%',
        maxWidth: '800px',
        margin: '1rem auto',
        // aspectRatio: '16 / 9',
        borderRadius: '8px',
        overflow: 'hidden',
        backgroundColor: 'rgba(0, 0, 0, 0.4)',
        maskImage: `linear-gradient(to right, transparent, white 2%, white 98%, transparent), 
                    linear-gradient(to bottom, transparent, white 2%, white 98%, transparent)`,
        WebkitMaskImage: `linear-gradient(to right, transparent, white 2%, white 98%, transparent), 
                          linear-gradient(to bottom, transparent, white 2%, white 98%, transparent)`,
        maskComposite: 'intersect',
        WebkitMaskComposite: 'source-in',
          }}
         >

{showPoster && (
  <div className='hover-brighten'
    onClick={() => {
      const internal = playerRef.current?.getInternalPlayer();
      if (!internal) return;

      internal.play();       // start video
      setShowPoster(false);  // hide poster
    }}

    style={{
      position: 'absolute',
      inset: 0,
      zIndex: 5,
      cursor: 'pointer',
      background: 'rgba(0,0,0,0.2)',
    }}
  >
    <img
      src={intro}
      alt="Video poster"
      style={{
        width: '100%',
        height: '120%',
        objectFit: 'cover',
      }}
    />

    {/* Play icon */}
    <div
      style={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        pointerEvents: 'none',
      }}
    >
      <Play  
      size={64}
      strokeWidth={2.5}
        style={{
          color: 'silver',
          }}     
/>
    </div>
  </div>
)}





        <ReactPlayer
        ref={playerRef}
        // url={videoUrl} 
        url={`${CF_BASE}/public/RR-RepublicPITCH-tl14-v03-POST (1).mp4`}
        controls={isMobile}   
        width="100%"
        height="100%"
        volume={volume}
        muted={muted}
        onPlay={handlePlay}              // ✅ REAL playback
        onPause={handlePause}
        onEnded={handleEnded}
        onProgress={handleProgress}
        onDuration={handleDuration}
        config={{
          file: {
            attributes: {
              playsInline: isMobile,      // ✅ mobile inline, desktop unaffected
        controls: isMobile,         // ✅ REQUIRED for iOS
        disablePictureInPicture: !isMobile,
            }
          }
        }}
      />

{ !isMobile && hasStarted && showControls && (
      <div className="netflix-controls"
      style={{
        bottom: '0px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '20px',
        padding: '10px 20px',
        width: '100%',
        maxWidth: '100vw',
        zIndex: 10,
      }}>
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '5%',
            position: 'absolute',
            bottom: '90%',
            width: '100%',
            zIndex: 2,
          }}
         >
          <Button
            onClick={handleRewind15}
            style={{
              backgroundColor: 'transparent',
              border: 'none',
              color: 'white',
              cursor: 'pointer',
              position: 'relative',
              width: '48px',
              height: '48px',
              padding: 0,
              margin: '2%'
            }}
          >
            <RotateCcw
              size={48}
              strokeWidth={2.5}
              style={{
                color: 'silver',
                position: 'absolute',
                top: 0,
                left: 0,
              }}
            />
            <span
              style={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                fontSize: '14px',
                color: 'white',
                pointerEvents: 'none',
              }}
            >
              15
            </span>
          </Button>

          <Button
            className="center-play-button"
            onClick={togglePlayPause}
            style={{
              backgroundColor: 'transparent',
              color: 'white',
              border: 'none',
              padding: '20px',
              borderRadius: '50%',
              cursor: 'pointer',
              fontSize: '100px',
              zIndex: 2,
            }}
          >
            {isPlaying ? (
              <Pause
                fill="currentColor"
                size={64}
                strokeWidth={2.5}
                style={{
                  color: 'silver',
                }}
              />
            ) : (
              <Play
                fill="currentColor"
                size={64}
                strokeWidth={2.5}
                style={{
                  color: 'silver',
                }}
              />
            )}
          </Button>

          <Button
            onClick={handleForward15}
            style={{
              backgroundColor: 'transparent',
              border: 'none',
              color: 'white',
              cursor: 'pointer',
              position: 'relative',
              width: '48px',
              height: '48px',
              padding: 0,
              margin: '2%'
            }}
          >
            <RotateCw
              size={48}
              strokeWidth={2.5}
              style={{
                color: 'silver',
                position: 'absolute',
                top: 0,
                left: 0,
              }}
            />
            <span
              style={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                fontSize: '14px',
                color: 'white',
                pointerEvents: 'none',
              }}
            >
              15
            </span>
          </Button>
        </div>



      
    <div className="sliders-container"
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '10px',
        width: '100%',
        padding: '0 20px'
      }}>
      <input
        ref={sliderRef}
        className="player-slider"
        type="range"
        min={0}
        max={1}
        step={0.01}
        value={played}
        onChange={(e) => playerRef.current.seekTo(parseFloat(e.target.value))}
        onMouseMove={(e) => {
          if (!sliderRef.current) return;
          const rect = sliderRef.current.getBoundingClientRect();
          const x = e.clientX - rect.left;
          const ratio = x / rect.width;
          const time = ratio * totalTime;
          const timeRemaining = totalTime - (ratio * totalTime);
          setHoverTime(timeRemaining);
          setHoverTime(time);
          setHoverX(x);
        }}
        onMouseLeave={() => {
          setHoverTime(null);
          setHoverX(null);
        }}
        style={{ '--played': played }}
      />
      {hoverTime !== null && (
          <div
            className="slider-tooltip"
            style={{
              left: `${hoverX}px`
            }}
          >
            {formatTime(hoverTime)}
          </div>
        )}
        <div className="time-display">
        <CardText>
          {formatTime(currentTime)}/{formatTime(totalTime)}
        </CardText>
        </div>
        
        <div
        style={{ position: 'relative', cursor: 'pointer', display: 'inline-block' }}
        onMouseEnter={() => {
          clearTimeout(hideTimeoutRef.current);
          setShowVolumeSlider(true);
        }}
        onMouseLeave={() => {
          hideTimeoutRef.current = setTimeout(() => {
            setShowVolumeSlider(false);
          }, 300);
        }}
      >
        {muted ? (
          <VolumeX 
            color="silver" 
            size={24}
            onClick={toggleMute}
          />
        ) : (
          <Volume2 
            color="silver" 
            size={24}
            onClick={toggleMute}
          />
        )}

        {showVolumeSlider && (
          <input
            type="range"
            min={0}
            max={1}
            step={0.05}
            value={volume}
            onChange={(e) => {
              const newVolume = parseFloat(e.target.value);
              setVolume(newVolume);
              if (newVolume === 0) {
                setMuted(true);
              } else {
                setMuted(false);
              }
            }}
            className="custom-slider volume-slider"
            style={{
              position: 'absolute',
              bottom: '80px',
              left: '50%',
              transform: 'translateX(-50%) rotate(-90deg)',
              width: '100px',
              height: '8px',
              zIndex: 10,
              '--progress': `${volume * 100}%`
            }}
            onClick={(e) => e.stopPropagation()}
          />
        )}
      </div>

      <div
        style={{ position: 'relative', cursor: 'pointer', display: 'inline-block', marginLeft: '1%' }}
        onClick={handleToggleFullscreen}
        title={isFullscreen ? "Exit Fullscreen" : "Fullscreen"}
      >
        {isFullscreen ? (
          <Minimize color="silver" size={24} />
        ) : (
          <Maximize color="silver" size={24} />
        )}
      </div>

        </div>
        
      </div>
      )}
    </div>    



          <Card
            style={{
              marginRight: '5%',
              marginLeft: '5%',
              marginTop: '10%',
              marginBottom: '10%',                      
              borderRadius: '8px',                    
            }}
          >
  <div className='d-flex justify-content-center '>
       <h2
       style={{
       display: "inline-block",
        padding: '1%',
        justifyContent: 'center',
        fontWeight: "bold",
        fontSize: "1.5rem",
        padding: "0.2rem 0.6rem",
        margin: "0",  
        marginBottom: "2rem",          
        backgroundColor: 'rgba(20, 19, 19, 0.9)',
        backdropFilter: 'blur(8px)',           
        WebkitBackdropFilter: 'blur(8px)',
        borderRadius: '12px',
        // border: '2px solid rgb(179, 37, 25)',
        // boxShadow: `
        //   0 0 5px rgba(243, 174, 61, 0.6),
        //   0 0 10px rgba(243, 174, 61, 0.35)
        // `,          
          }}
     >
      Executive Team
     </h2>
   </div>
<div style={{
  display: 'flex',          
  justifyContent: 'center',
  // marginTop: '2rem',
  marginBottom: '8%',
}}>
  <div className="hover-card"
  style={{
    backgroundColor: 'rgba(20, 19, 19, 0.7)',
    backdropFilter: 'blur(8px)',
    WebkitBackdropFilter: 'blur(8px)',
    maxWidth: '250px',       
    textAlign: 'center',
    borderRadius: '12px',
     borderRadius: '12px',
            border: '2px solid rgb(179, 037, 025)',
            boxShadow: `
              0 0 8px rgba(243, 174, 61, 0.6),
              0 0 20px rgba(243, 174, 61, 0.35)
            `,
  }}>
    <img 
      src={Robert} 
      alt="Robert" 
      style={{
        width: '100%',
        borderRadius: '12px',
        display: 'block',
      }}
    />

    <h2 style={{ margin: '0.5rem 0 0 0', fontWeight: 'bold', justifyContent: 'center', }}>Robert Rodriguez</h2>
    <h3 style={{ margin: '0.2rem 0 0 0', fontWeight: 'bold', justifyContent: 'center', }}>Founder</h3>
  </div>
</div>



<div className="team-grid">
  {/* Alexis */}
  <div className="card-wrapper">
    <div className="about-us-card"
      style={{
        backgroundColor: 'rgba(20, 19, 19, 0.7)',
        backdropFilter: 'blur(8px)',
        WebkitBackdropFilter: 'blur(8px)',
        maxWidth: '250px',
        textAlign: 'center',
        borderRadius: '12px',
        border: '2px solid rgb(179, 037, 025)',
        boxShadow: `
          0 0 8px rgba(243, 174, 61, 0.6),
          0 0 20px rgba(243, 174, 61, 0.35)
        `,
      }}
    >
      <img
        src={Alexis}
        alt="Alexis Garcia"
        style={{
          width: '100%',
          borderRadius: '12px',
          display: 'block',
        }}
      />
      <h2 style={{ margin: '0.5rem 0 0 0', fontWeight: 'bold' }}>Alexis Garcia</h2>
      <h3 style={{ margin: '0.2rem 0 0 0', fontWeight: 'bold' }}>Co-Founder</h3>
    </div>
  </div>

  {/* Kevin */}
  <div className="card-wrapper">
    <div className="about-us-card"
      style={{
        backgroundColor: 'rgba(20, 19, 19, 0.7)',
        backdropFilter: 'blur(8px)',
        WebkitBackdropFilter: 'blur(8px)',
        maxWidth: '250px',
        textAlign: 'center',
        borderRadius: '12px',
        border: '2px solid rgb(179, 037, 025)',
        boxShadow: `
          0 0 8px rgba(243, 174, 61, 0.6),
          0 0 20px rgba(243, 174, 61, 0.35)
        `,
      }}
    >
      <img
        src={Kevin}
        alt="Kevin Dartt"
        style={{
          width: '100%',
          borderRadius: '12px',
          display: 'block',
        }}
      />
      <h2 style={{ margin: '0.5rem 0 0 0', fontWeight: 'bold' }}>Kevin Dartt</h2>
      <h3 style={{ margin: '0.2rem 0 0 0', fontWeight: 'bold' }}>CEO</h3>
    </div>
  </div>

  {/* Nixon */}
  <div className="card-wrapper">
    <div className="about-us-card"
      style={{
        backgroundColor: 'rgba(20, 19, 19, 0.7)',
        backdropFilter: 'blur(8px)',
        WebkitBackdropFilter: 'blur(8px)',
        maxWidth: '250px',
        textAlign: 'center',
        borderRadius: '12px',
        border: '2px solid rgb(179, 037, 025)',
        boxShadow: `
          0 0 8px rgba(243, 174, 61, 0.6),
          0 0 20px rgba(243, 174, 61, 0.35)
        `,
      }}
    >
      <img
        src={Nixon}
        alt="Nixon Guerrero"
        style={{
          width: '100%',
          borderRadius: '12px',
          display: 'block',
        }}
      />
      <h2 style={{ margin: '0.5rem 0 0 0', fontWeight: 'bold' }}>Nixon Guerrero</h2>
      <h3 style={{ margin: '0.2rem 0 0 0', fontWeight: 'bold' }}>COO</h3>
    </div>
  </div>

  {/* Nick */}
  <div className="card-wrapper">
    <div className="about-us-card"
      style={{
        backgroundColor: 'rgba(20, 19, 19, 0.7)',
        backdropFilter: 'blur(8px)',
        WebkitBackdropFilter: 'blur(8px)',
        maxWidth: '250px',
        textAlign: 'center',
        borderRadius: '12px',
        border: '2px solid rgb(179, 037, 025)',
        boxShadow: `
          0 0 8px rgba(243, 174, 61, 0.6),
          0 0 20px rgba(243, 174, 61, 0.35)
        `,
      }}
    >
      <img
        src={Nick}
        alt="Nicholas Ortiz"
        style={{
          width: '100%',
          borderRadius: '12px',
          display: 'block',
        }}
      />
      <h2 style={{ margin: '0.5rem 0 0 0', fontWeight: 'bold' }}>Nicholas Ortiz</h2>
      <h3 style={{ margin: '0.2rem 0 0 0', fontWeight: 'bold' }}>CTO</h3>
    </div>
  </div>

</div>

          </Card>





    </div>
  );
}
